import { SxProps } from "@mui/material";

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    height: '100%'
}

export const sxQuestionTextField: SxProps = {
    '.MuiOutlinedInput-root': {
        height: 'fit-content'
    },
    fieldset: {
        display: 'flex',
        boxSizing: 'border-box'
    },
    textarea: {
        fontFamily: 'Unimed-Sans',
        color: '#383838',
        fontSize: '14px',
    }
}

export const sxRadioGroup: SxProps = {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 90px)',
    width: '100%',
    gap: '8px',

    '@media(max-width: 1120px)': {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '5px',
        flexWrap: 'nowrap'
    },
    '.MuiFormControlLabel-root': {
        margin: 0,
        width: '100%',
        minWidth: '54px'
    }
}

export const sxLabel: SxProps = {
    '.MuiFormControlLabel-label': {
        textAlign: 'center',
        fontSize: '14px'
    }
}

export const sxSubtitle: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
  marginTop: '30px',
}
